<template>
  <div class="search-panel-label">
    {{ titleText }}
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

// Section label inside the "Erweiterte Suche" panels
@Component
export default class FilterSectionTitle extends Vue {
  @Prop({ default: '' }) titleText?: string;

  // kept for the callers; the design shows no tooltips in the filter panel
  @Prop({ default: '' }) tooltipText?: string;
}
</script>
